import { motion } from 'framer-motion';
import { Flame } from '@/lib/category-icons';

interface StreakBadgeProps {
  streak: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export function StreakBadge({ streak, size = 'md', showLabel = true }: StreakBadgeProps) {
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs gap-1',
    md: 'px-3 py-1.5 text-sm gap-1.5',
    lg: 'px-4 py-2 text-base gap-2',
  };

  const iconSizes = {
    sm: 'w-3.5 h-3.5',
    md: 'w-4.5 h-4.5',
    lg: 'w-5 h-5',
  };

  if (streak === 0) {
    return (
      <div
        className={`flex items-center ${sizeClasses[size]} rounded-full bg-charcoal-800 text-slate-500`}
      >
        <Flame className={iconSizes[size]} />
        <span className="font-medium">0</span>
        {showLabel && <span className="opacity-75">days</span>}
      </div>
    );
  }

  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={`flex items-center ${sizeClasses[size]} rounded-full bg-amber-500/20 text-amber-400 border border-amber-500/30`}
    >
      <motion.span
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, -10, 10, 0],
        }}
        transition={{
          duration: 0.5,
          repeat: Infinity,
          repeatDelay: 3,
        }}
        className="inline-flex"
      >
        <Flame className={iconSizes[size]} />
      </motion.span>
      <span className="font-bold">{streak}</span>
      {showLabel && (
        <span className="opacity-75">
          {streak === 1 ? 'day' : 'days'}
        </span>
      )}
    </motion.div>
  );
}
